import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import useSchemas from "../hooks/useSchemas"

function SEO({
  description,
  lang,
  meta,
  title,
  pathname,
  robots,
  preload,
  youtubeSchemas = [],
  schemaData,
  bodyClassName,
  hasSmileSnap
}) {
  const { site, schema, social } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            fullPracticeName
          }
        }
        schema: allDataJson(filter: { schemaGeneral: { ne: null } }) {
          nodes {
            schemaGeneral
          }
        }
        social: allDataJson(filter: { optionsItem: { eq: "siteVariables" } }) {
          nodes {
            socialImage
          }
        }
      }
    `
  )

  const { schemas } = useSchemas(schemaData)
  const combinedSchemas = schemas.concat(youtubeSchemas)

  let schemaJson = JSON.stringify(
    {
      "@context": {
        "@vocab": "https://schema.org/"
      },
      "@graph": combinedSchemas
    },
    null,
    2
  )

  const socialImage = social.nodes[0].socialImage

  const metaRobots = robots

  const metaDescription = description || site.siteMetadata.description

  const siteUrl = site.siteMetadata.siteUrl

  const practiceName = site.siteMetadata.fullPracticeName

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      bodyAttributes={{
        class: bodyClassName
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: title
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          property: `og:image`,
          content: socialImage
        },
        {
          property: `og:image:width`,
          content: `1200`
        },
        {
          property: `og:image:height`,
          content: `627`
        },
        {
          property: `og:image:alt`,
          content: practiceName
        },
        {
          property: `og:url`,
          content: `${siteUrl}${pathname || "/"}`
        },
        {
          name: `robots`,
          content: metaRobots
        }
      ].concat(meta)}>
      {preload &&
        preload.map(item => (
          <link key={item.href} rel="preload" as={item.as} href={item.href} />
        ))}

      {combinedSchemas.length > 0 && (
        <script type="application/ld+json">{schemaJson}</script>
      )}

      {/* {hasSmileSnap && (
        <script type="text/javascript">
          {` window.__smilesnap = window.__smilesnap || [];
            window.__smilesnap.cid = 'YFLh1keHT3tjwjyUAAjtvndi';
            (function() {
            var ss = document.createElement('script'); ss.type = 'text/javascript'; ss.async = true;
            ss.src = 'https://cdn-scripts.smilesnap.com/js/loader.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(ss, s);
            })();`}
        </script>
      )} */}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

export default SEO
